// import { Form, TimePicker, DatePicker, Typography } from "antd";
// import moment from "moment";
// export const CitiesDateTimePicker = ({
//   withoutForm,
//   name,
//   label,
//   disabled,
//   required,
//   message,
//   value,
//   rangePicker,
//   datePicker,
//   onlyDate,
//   ...props
// }) => {
//   return (
//     <>
//       {withoutForm ? (
//         datePicker ? (
//           <DatePicker
//             disabled={disabled || false}
//             value={value ? moment(value, "YYYY-MM-DD") : ""}
//             style={{ width: "100%" }}
//             {...props}
//           />
//         ) : rangePicker ? (
//           <DatePicker.RangePicker
//             disabled={disabled || false}
//             value={value ? moment(value, "YYYY-MM-DD") : ""}
//             style={{ width: "100%" }}
//             {...props}
//           />
//         ) : (
//           <TimePicker
//             disabled={disabled || false}
//             value={moment(value || "00:00")}
//             format="HH:mm A"
//             style={{ width: "100%" }}
//             {...props}
//           />
//         )
//       ) : (
//         <Form.Item
//           name={name}
//           label={<Typography.Text strong>{label}</Typography.Text>}
//           rules={[
//             {
//               required,
//               message,
//             },
//           ]}
//         >
//           {datePicker ? (
//             <DatePicker
//               disabled={disabled || false}
//               value={value ? moment(value, "YYYY-MM-DD") : ""}
//               style={{ width: "100%" }}
//               {...props}
//               format={onlyDate ? "YYYY-MM-DD" : "YYYY-MM-DD hh:mm A"}
//               showTime={{ use12Hours: true }}
//             />
//           ) : rangePicker ? (
//             <DatePicker.RangePicker
//               disabled={disabled || false}
//               value={value ? moment(value, "YYYY-MM-DD") : ""}
//               style={{ width: "100%" }}
//               {...props}
//             />
//           ) : (
//             <TimePicker
//               disabled={disabled || false}
//               value={moment(value || "00:00")}
//               format="HH:mm A"
//               style={{ width: "100%" }}
//               {...props}
//             />
//           )}
//         </Form.Item>
//       )}
//     </>
//   );
// };

import { Form, TimePicker, DatePicker, Typography } from "antd";
import dayjs from "dayjs";

export const CitiesDateTimePicker = ({
  withoutForm,
  name,
  label,
  disabled,
  required,
  message,
  value,
  rangePicker,
  datePicker,
  onlyDate,
  ...props
}) => {
  return (
    <>
      {withoutForm ? (
        datePicker ? (
          <DatePicker
            disabled={disabled || false}
            value={value ? dayjs(value, "YYYY-MM-DD") : null}
            style={{ width: "100%" }}
            {...props}
          />
        ) : rangePicker ? (
          <DatePicker.RangePicker
            disabled={disabled || false}
            value={
              value && Array.isArray(value)
                ? [
                    value[0] ? dayjs(value[0]) : null,
                    value[1] ? dayjs(value[1]) : null,
                  ]
                : null
            }
            style={{ width: "100%" }}
            {...props}
          />
        ) : (
          <TimePicker
            disabled={disabled || false}
            value={value ? dayjs(value, "HH:mm") : null}
            format="HH:mm A"
            style={{ width: "100%" }}
            {...props}
          />
        )
      ) : (
        <Form.Item
          name={name}
          label={<Typography.Text strong>{label}</Typography.Text>}
          rules={[
            {
              required,
              message,
            },
          ]}
        >
          {datePicker ? (
            <DatePicker
              disabled={disabled || false}
              value={value ? dayjs(value, "YYYY-MM-DD") : null}
              style={{ width: "100%" }}
              {...props}
              format={onlyDate ? "YYYY-MM-DD" : "YYYY-MM-DD hh:mm A"}
              showTime={onlyDate ? false : { use12Hours: true }}
            />
          ) : rangePicker ? (
            <DatePicker.RangePicker
              disabled={disabled || false}
              value={value ? dayjs(value, "YYYY-MM-DD") : null}
              style={{ width: "100%" }}
              {...props}
            />
          ) : (
            <TimePicker
              disabled={disabled || false}
              value={value ? dayjs(value, "HH:mm") : null}
              format="HH:mm A"
              style={{ width: "100%" }}
              {...props}
            />
          )}
        </Form.Item>
      )}
    </>
  );
};
